import { AnimatePresence } from "framer-motion";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";


import "./App.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Cookies from "./components/Cookies";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, } from "react";
import { fetchBlogs } from "./app/features/blogSlice";
import { fetchCountry } from "./app/features/countrySlice";
// import FloatingDownloadButton from "./components/BUTTONS/FloatingDownloadButton";


import { getWithExpiry } from "./utils/storage.js";

import APP_ROUTES from "./routes/index.js";



function RequireAuth({ children }) {

  let location = useLocation();

  function getQueryParam(name, search) {
    const params = new URLSearchParams(search);
    return params.get(name);
  }
  const event_id = getQueryParam('event_id', location.search);
  const rsvpManagerSession = getWithExpiry('rsvp-manager-session-' + event_id);

  console.log('RequireAuth rsvpManagerSession', rsvpManagerSession);
  console.log('RequireAuth event_id', event_id);

  if (!Boolean(rsvpManagerSession?.length)) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to={`/rsvp-auth?event_id=${event_id}`} state={{ from: location, }} replace />;
  }

  return children;


}



const RemoveTrailingSlash = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Remove trailing slash if it exists and there are path segments
    if (location.pathname !== '/' && location.pathname.endsWith('/')) {
      // Remove the trailing slash
      const newPath = location.pathname.slice(0, -1);
      // Redirect to the new path without a trailing slash
      navigate(newPath, { replace: true });
    }
  }, [location, navigate]);

  return null;
};



function App() {
  const location = useLocation();
  const navigate = useNavigate();

  AOS.init({
    // Global settings:
    disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
    startEvent: "DOMContentLoaded", // name of the event dispatched on the document, that AOS should initialize on
    initClassName: "aos-init", // class applied after initialization
    animatedClassName: "aos-animate", // class applied on animation
    useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
    disableMutationObserver: false, // disables automatic mutations' detections (advanced)
    debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
    throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

    // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
    offset: 120, // offset (in px) from the original trigger point
    delay: 0, // values from 0 to 3000, with step 50ms
    duration: 700, // values from 0 to 3000, with step 50ms
    easing: "ease", // default easing for AOS animations
    once: false, // whether animation should happen only once - while scrolling down
    mirror: false, // whether elements should animate out while scrolling past them
    anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
  });

  // Parse the query parameters
  const searchParams = new URLSearchParams(location.search);
  // Get the value of the 'track_user' parameter
  const trackUser = searchParams.get('track_user');

  const cookieAccepted = localStorage.getItem("cookieAccepted");
  const dispatch = useDispatch();
  const blogStatus = useSelector((state) => state.blogs.status);
  const geoDetailsStatus = useSelector((state) => state.geoDetails.status);

  // getBlogs
  useEffect(() => {
    if (blogStatus === "idle") {
      dispatch(fetchBlogs());
    }
    // eslint-disable-next-line
  }, [blogStatus]);

  // getCountry
  useEffect(() => {
    if (geoDetailsStatus === "idle") {
      dispatch(fetchCountry());
    }
    // eslint-disable-next-line
  }, [geoDetailsStatus]);

  // useEffect(() => {
  //   if (location.pathname.endsWith('/') && location.pathname !== '/') {
  //     window.history.replaceState(null, '', location.pathname.slice(0, -1) + location.search);
  //   }
  // }, [location]);

  // useEffect(() => {
  //   // Remove trailing slash if it exists and there are path segments
  //   if (location.pathname !== '/' && location.pathname.endsWith('/')) {
  //     // Remove the trailing slash
  //     const newPath = location.pathname.slice(0, -1);
  //     // Redirect to the new path without a trailing slash
  //     navigate(newPath, { replace: true });
  //   }
  // }, [location, navigate]);


  // useEffect(() => {
  //   // Split the pathname by the slash and check each segment
  //   const pathSegments = location.pathname.split('/').filter(Boolean);

  //   // If any segment ends with a slash, remove the trailing slash
  //   if (pathSegments.length > 1 && location.pathname.endsWith('/')) {
  //     // Create the new path by removing the trailing slash
  //     const newPath = location.pathname.slice(0, -1);

  //     // Replace the current URL with the new path without the trailing slash
  //     navigate(newPath, { replace: true });
  //   }
  // }, [location, navigate]);



  return (
    <>
      {/* {!cookieAccepted && <Cookies />} */}
      {(trackUser != '0' && !cookieAccepted) && <Cookies />}
      <div className="fixed top-[12vh] z-[1000]">
        <ToastContainer />
        {/* <FloatingDownloadButton /> */}
      </div>
      <RemoveTrailingSlash />
      {
        <AnimatePresence mode="wait">
          <Routes location={location} key={location.pathname}>
            {APP_ROUTES.map(({ path, component, requireAuth }) => (
              <Route
                key={path}
                path={path}
                element={
                  requireAuth ? (
                    <RequireAuth>{component}</RequireAuth>
                  ) : (
                    component
                  )
                }
              />
            ))}

          </Routes>
        </AnimatePresence>
      }
    </>
  );
}

export default App;
